import { Box } from "@mui/material";
import { CustomInput, CustomSelect } from "../../../components-new/common";
import { useDispatch } from "react-redux";
import { setEditStep } from "../../../Redux/TestAuthoring/TestAuthoring";

const Conditions = ({ item }) => {
  const dispatch = useDispatch();

  const handleChange = (value, field) => {
    dispatch(setEditStep({ ...item, [field]: value }));
  };

  return (
    <Box pr={3}>
      <Box display="flex" columnGap={2} mb={3}>
        <CustomSelect
          label={"Condition Logic"}
          options={[
            { label: "If-True", value: "if-true" },
            { label: "If-False", value: "if-false" }
          ]}
          width={"100%"}
          background={"#ffffff"}
          value={item.condLogic || ""}
          onChange={(e) => handleChange(e.target.value, "condLogic")}
        />
      </Box>
      <Box>
        <CustomInput
          labelinput={"Condition Expression"}
          placeholder={"Enter condition expression (max 1000 characters)"}
          value={item.condexp || ""}
          onChange={(e) => {
            const value = e.target.value;
            if (value.length <= 1000) {
              handleChange(value, "condexp");
            }
          }}
          multiline
          rows={4}
          inputProps={{ maxLength: 1000 }}
        />
      </Box>
    </Box>
  );
};

export default Conditions; 